
import loadComponentArticle from './infiniteScrooll';

// Tambahkan event listener untuk complete.te.infiniteScroll
window.addEventListener('complete.te.infiniteScroll', () => {
    // Panggil loadComponentArticle saat complete.te.infiniteScroll terpicu
    loadComponentArticle(baseUrl + '/home/infinite');
});
